document.addEventListener("DOMContentLoaded", (event) => {
  const custom_member_dropdown_wrapper = document.querySelector(".custom_member_dropdown_logoff");
  const custom_member_dropdown_trigger = document.querySelector(".custom_member_dropdown_trigger");
  const custom_mobile_member_button_trigger = document.querySelector(".custom_mobile_member_button_trigger");
  
  if (custom_member_dropdown_trigger) {
    custom_member_dropdown_trigger.addEventListener('click', function() {
      custom_member_dropdown_wrapper.classList.toggle('show');
    });
    document.addEventListener('click', function(event) {
      if (
        custom_member_dropdown_wrapper.classList.contains('show') &&
        !custom_member_dropdown_wrapper.contains(event.target) &&
        !custom_member_dropdown_trigger.contains(event.target)
      ) {
        custom_member_dropdown_wrapper.classList.remove('show');
      }
    });
  }
  
  if (custom_mobile_member_button_trigger) {
    custom_mobile_member_button_trigger.addEventListener('click', function(event) {
      console.log("ssd", this);
      this.classList.toggle('show');
    });
    document.addEventListener('click', function(event) {
      if (
        custom_mobile_member_button_trigger.classList.contains('show') &&
        !custom_mobile_member_button_trigger.contains(event.target) &&
        !custom_mobile_member_button_trigger.contains(event.target)
      ) {
        custom_mobile_member_button_trigger.classList.remove('show');
      }
    });
  }
});